export enum ProviderStatus {
  DISABLED = 1,
  LOCAL = 1 << 1
}